<template>
  <div class="englobe-params">
    <div class="params-row">
      <RadioButtons
        :active-option="source"
        :options="options"
        @select-option="source = $event"
      />
    </div>

    <!--  -->
    <div class="params-row">
      <TotalMatched :item-count="itemCount" />

      <DropdownMenu
        v-model="pageSize"
        :options="[10, 20, 50, 100]"
        label="Vidéos par page :"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useTranscriptionsStore } from "@/follaw-fr/stores/transcriptions";
import RadioButtons from "../../reusable/atoms/RadioButtons.vue";
import { computed } from "vue";
import TotalMatched from "../../reusable/atoms/TotalMatched.vue";
import DropdownMenu from "../../reusable/atoms/DropdownMenu.vue";
import { getInstitutionsNames } from "@/follaw-fr/utils/institutions.utils";

const { source, availableFilters, itemCount, pageSize } = storeToRefs(
  useTranscriptionsStore()
);

/** Generate options based on available filters (backend data) */
const options = computed(() => {
  if (!availableFilters.value?.source) {
    return [];
  }
  return [
    { label: "Tous", value: null },
    ...availableFilters.value.source.map((item: string) => ({
      label: getInstitutionsNames(item) ?? item,
      value: item,
    })),
  ];
});
</script>
